import { createSlice } from "@reduxjs/toolkit";
import _ from "lodash";

const initialState = {
  data: null,
};
export const slice = createSlice({
  name: "mediaList",
  initialState: _.cloneDeep(initialState),
  reducers: {
    setMediaList: (state, action) => {
      state.data = action.payload;
    },
  },
});

export const { setMediaList } = slice.actions;

export default slice.reducer;
